import { Stack, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import TiejunPicker from "src/components/common/TiejunPicker";
import MerchantInfo from "src/components/common/MerchantInfo";
import UserPicker from "src/components/common/UserPicker";

const BindMerchantParentDialog = ({ merchant, open, onFinish, onClose }) => {
  const [parent, setParent] = useState({});

  const [form, setForm] = useState({
    remark: ''
  });

  useEffect(() => {
    setParent(merchant.parent);
  }, [merchant])

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    const { msg } = await asyncRequest({
      path: "/merchant/bindParent",
      data: { 
        mid: merchant.mid, uid: parent.uid,
        ...form
      },
    });


    setForm({
      remark: "",
    });
    alert(msg, "success");
    onFinish();
  }

  function handleSelectTiejun() {
    TiejunPicker({
      onSelect(val) {
        setParent(val.user);
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setParent(val);
      },
    });
  }

  return (
    <FormDialog title="修改推荐人" open={open} onClose={onClose} onConfirm={handleDialogConfirm} sx={{minWidth: 200}}>
      <FormItem title="商户" required>
        <Stack direction="row" alignItems="center" spacing={2}>
          <MerchantInfo {...merchant} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="推荐人" required>
        <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectUser}>
          <UserInfo {...(parent || {})} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="理由" required>
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default BindMerchantParentDialog;
